module.exports = __webpack_public_path__ + "public/img/w5.675fc8ac.png";